module.exports = __webpack_public_path__ + "img/1F92C.62e3c7bb.svg";